module.exports = __webpack_public_path__ + "img/banner.85565ca9.png";